<template>
  <div>
    <SysDialog
      v-model="dialog"
      :largura="800"
      titulo="Estoque de segurança por Curva"
      @click:primary="salvarEsseg()"
      @click:hidden-dialog="$emit('fechar-dialog-curvas', false)"
    >
      <table id="tabela-curvas-coberturas">
        <tr class="text-left font-13 font-weight-medium">
          <td class="pl-3">Frequência</td>
          <td>Faturamento</td>
          <td>Cobertura</td>
        </tr>

        <tr>
          <td colspan="3" style="border-bottom: 1px solid #d3d3d3; padding-bottom: 7px;" />
        </tr>

        <tr
          v-for="(item, index) in coberturas"
          :key="index"
        >
          <td v-text="item.classificacao_popularidade" class="pl-3" />
          <td v-text="item.classificacao_criticidade" />
          <td class="w-100">
            <div class="d-flex align-center justify-center pb-2 pr-2">
              <TextFieldFormatadorDeValor
                v-model="item.tempo_cobertura_esseg"
                dense
                class="input-cobertura-estoque-seguranca text-field-centralizado"
                hide-details
                suffix="dias"
                @focus="$event.target.select()"
                @keydown.enter="salvarEsseg()"
              />
            </div>
          </td>
        </tr>
      </table>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { buscarCurvasFornecedor, salvarEssegCurvasFornecedor } from "./RequisicoesAPI";
import { logout } from "@/helpers";
import TextFieldFormatadorDeValor from '../../utils/TextFieldFormatadorDeValor.vue';

export default {
  name: 'CurvaS',
  components: { SysDialog, TextFieldFormatadorDeValor },
  props: {
    fornecedor: {
      type: Object,
      required: true
    },
    cobertura_selecionada: {
      type: Number
    }
  },
  data: () => ({
    dialog: false,
    coberturas: []
  }),
  computed: {
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    }
  },
  watch: {
    cobertura_selecionada(valor) {
      const validador = valor === 1;
      this.dialog = validador;
      if (validador) {
        this.$store.dispatch(
          "loading/addRequisicao",
          buscarCurvasFornecedor({ id_grupo: this.GRUPO_COMPRA })
            .then(coberturas => this.coberturas = coberturas)
            .catch(logout)
        );
      }
    }
  },
  methods: {
    salvarEsseg() {
      const parametros = {
        id_grupo: this.GRUPO_COMPRA,
        id_fornecedor: this.fornecedor.id,
        ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N',
        tipo_esseg: this.cobertura_selecionada,
        coberturas: this.coberturas
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        salvarEssegCurvasFornecedor(parametros)
          .then(() => {
            this.dialog = false;
            this.$emit('fechar-dialog-curvas', true);
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style scoped>
#tabela-curvas-coberturas {
  width: 100%;
  border-collapse: collapse;
}
</style>
